//import { ApolloClient, InMemoryCache, gql } from "@apollo/client/core";
import { AuthProvider } from "react-admin";
import {
  CREDENTIALS_LOCAL_STORAGE_ITEM,
  USER_DATA_LOCAL_STORAGE_ITEM,
} from "../constants";
import { Credentials } from "../types";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { apolloClient } from "../data-provider/graphqlDataProvider";

export const jwtAuthProvider: AuthProvider = {
  login: async (credentials: Credentials) => {
    let data = {
      ...credentials,
      service: `${process.env.REACT_APP_AUTH_SERVICE}`
    }
    const userData = await axios.post(
      `${process.env.REACT_APP_LEMONADE_SERVER}/api/login`,
      data
    );
    console.log('login: ', userData)
    if (userData && userData.data.err) {
      let message = userData.data.err.message;
      let detailsMessages = userData.data.err.details.messages
      if (message === "Unauthorized" && detailsMessages.some((dm: any) => dm === "User is not registered yet"))
        return Promise.reject("NotRegistered");
      else if (message === "Unauthorized" && detailsMessages.some((dm: any) => dm === "The passed username/password are incorrect"))
        return Promise.reject("Incorrect");
      return Promise.reject();
    }
    else if (userData && userData.data) {
      localStorage.setItem(
        CREDENTIALS_LOCAL_STORAGE_ITEM,
        createBearerAuthorizationHeader(userData.data.accessToken)
      );
      localStorage.setItem(
        USER_DATA_LOCAL_STORAGE_ITEM,
        JSON.stringify(userData.data)
      );
      console.log('login resolve')
      return Promise.resolve();
    }
    return Promise.reject();
  },
  logout: () => {
    localStorage.removeItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
    localStorage.removeItem(USER_DATA_LOCAL_STORAGE_ITEM);
    apolloClient.clearStore().then()
    return Promise.resolve();
  },
  checkError: ({ status }: any) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () => {
    return localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM)
      ? Promise.resolve()
      : Promise.reject();
  },
  getPermissions: () => {
    const credentials = localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
    if (!credentials) {
      return Promise.reject();
    }
    try {
      const roles = getRoles();
      console.log("Roles: ", roles);
      return Promise.resolve(roles);
    } catch {
      return Promise.reject();
    }
  },
  getIdentity: () => {
    console.log('getIdentity');
    return Promise.resolve({
      id: "undefined",
      fullName: undefined,
      avatar: undefined,
    });
  },
};

export function createBearerAuthorizationHeader(accessToken: string) {
  return `Bearer ${accessToken}`;
}

export async function generateOtp(mobile: string) {
  try {
    const res = await axios.post(`${process.env.REACT_APP_LEMONADE_SERVER}/api/generate-otp`, {
      mobile: `0${mobile}`,
      service: process.env.REACT_APP_AUTH_SERVICE
    })

    if (res.data) {
      if (res.data.err) {
        throw res.data.err.details.messages[0] === "mobile must be a phone number" ? "شماره موبایل اشتباه وارد شده است" : "خطا در برقراری ارتباط";
      }
      return res.data;
    }
  } catch (error) {
    throw error;
  }
}

/** JWT may emit a single role as string or many as string[]. Always return string[]. */
export function normalizeRoles(roles: unknown): string[] {
  if (Array.isArray(roles)) {
    return roles.filter((r): r is string => typeof r === "string" && !!r);
  }
  if (typeof roles === "string" && roles.trim()) {
    return [roles.trim()];
  }
  return [];
}

function getAccessTokenFromStorage(): string | null {
  const credentials = localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
  if (!credentials) return null;
  const parts = credentials.trim().split(/\s+/);
  const token = parts.length > 1 ? parts[parts.length - 1] : parts[0];
  return token || null;
}

export function getRoles(): string[] {
  const accessToken = getAccessTokenFromStorage();
  if (!accessToken) return [];
  try {
    const decoded: any = jwt_decode(accessToken);
    return normalizeRoles(decoded?.roles);
  } catch {
    return [];
  }
}

export function checkTimeAuth() {
  const accessToken = getAccessTokenFromStorage();
  if (!accessToken) return;
  try {
    const decoded: any = jwt_decode(accessToken);
    const currentTime = Math.floor(Date.now() / 1000);
    if (decoded.exp && currentTime > decoded.exp) {
      jwtAuthProvider.logout(true);
    }
  } catch {
    // ignore invalid tokens
  }
}
